import { render, staticRenderFns } from "./PointsHistoryTable.vue?vue&type=template&id=69bba40c&scoped=true"
import script from "./PointsHistoryTable.vue?vue&type=script&lang=ts"
export * from "./PointsHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./PointsHistoryTable.vue?vue&type=style&index=0&id=69bba40c&prod&lang=scss"
import style1 from "./PointsHistoryTable.scss?vue&type=style&index=1&id=69bba40c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bba40c",
  null
  
)

export default component.exports